<template>
    <div class="box">
        <!-- 筛选条件 -->
        <div class="filtrate">
            <el-form ref="form" :model="form" label-width="90px" class="form" :inline="true">
                <el-form-item label="商户名称/编号" label-position="right" class="marginTop">
                    <el-input v-model="form.merchantNameOrMerchantId" size="small" placeholder="请输入商户名称或编号"></el-input>
                </el-form-item>
                <el-form-item label="产品类型" label-position="right" class="marginTop">
                    <el-select v-model="form.productCode" placeholder="请选择产品类型" clearable>
                        <el-option label="ZPOS-电签" value="1"></el-option>
                        <el-option label="FPOS-大机" value="2"></el-option>
                        <el-option label="ZPOS-买断版" value="3"></el-option>
                        <el-option label="FPOS-买断版" value="4"></el-option>
                        <el-option label="和融通" value="5"></el-option>
                        <el-option label="合利宝" value="6"></el-option>
                        <el-option label="电银" value="7"></el-option>
                        <el-option label="联动支付" value="8"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备SN号" label-position="right" class="marginTop">
                    <el-input v-model="form.snCode" size="small" placeholder="请输入设备SN号"></el-input>
                </el-form-item>
                <el-form-item label="联系人/手机号" label-position="right" class="marginTop">
                    <el-input v-model="form.nameOrPhoneNo" size="small" placeholder="请输入姓名或手机号"></el-input>
                </el-form-item>
                <el-form-item label="绑定状态" label-position="right" class="marginTop">
                    <el-select v-model="form.bindStatus" placeholder="请选择绑定状态" clearable>
                        <el-option label="未绑定" value="0"></el-option>
                        <el-option label="已绑定" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="激活状态" label-position="right" class="marginTop">
                    <el-select v-model="form.activateStatus" placeholder="请选择激活状态" clearable>
                        <el-option label="未激活" value="0"></el-option>
                        <el-option label="已激活" value="1"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="query">
                <el-button type="primary" icon="el-icon-search" @click="queryFunc">查询</el-button>
                <el-button icon="el-icon-delete" @click="clearFunc">重置</el-button>
                <el-button size="small" type="success" @click="onExport">导出</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="tab">
            <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading" :header-row-style="{ 'font-weight': 'bold', 'color': '#9196A0' }">
                <el-table-column prop="realName" label="会员" width="120">
                </el-table-column>
                <el-table-column prop="merchantName" label="商户名称" width="180">
                </el-table-column>
                <el-table-column prop="merchantId" label="商户编号" width="180">
                </el-table-column>
                <el-table-column prop="name" label="联系人" width="120">
                </el-table-column>
                <el-table-column prop="phoneNo" label="手机号" width="180">
                </el-table-column>
              <el-table-column prop="phoneNo" label="产品" width="180">
                <template slot-scope="scope">
                  <span v-if="scope.row.productCode == 1">ZPOS-电签</span>
                  <span v-if="scope.row.productCode == 2">FPOS-大机</span>
                  <span v-if="scope.row.productCode == 3">ZPOS-买断版</span>
                  <span v-if="scope.row.productCode == 4">FPOS-买断版</span>
                  <span v-if="scope.row.productCode == 5">和融通</span>
                  <span v-if="scope.row.productCode == 6">合利宝</span>
                  <span v-if="scope.row.productCode == 7">电银</span>
                  <span v-if="scope.row.productCode == 8">联动支付</span>
                </template>
              </el-table-column>
                <el-table-column prop="snCode" label="设备SN号" width="180">
                </el-table-column>
                <el-table-column prop="bindTime" label="绑定时间" width="180">
                </el-table-column>
                <el-table-column prop="activateStatus" label="激活状态">
                    <template slot-scope="scope">
                        {{ scope.row.activateStatus == 0 ? '否' : '是' }}
                    </template>
                </el-table-column>
                <el-table-column prop="activateTime" label="激活时间" width="180">
                </el-table-column>

                <el-table-column label="操作" width="180" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="goDetail(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 分页 -->
        <div class="paginationBox">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagelndex" :page-sizes="[10, 20, 30, 40]" layout="total, sizes, prev, pager, next, jumper"
                :total="total" class="pagination">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import merchantApi from '@/api/merchant/manage.js';
import {getCookie} from '@/utils/base.js';
import qs from "qs";
export default {
    data() {
        return {
            form: {
                merchantNameOrMerchantId: '', // 商户名称/编号
                productCode: '', // 产品类型
                snCode: '', // 设备SN号
                nameOrPhoneNo: '', // 联系人/电话号码
                bindStatus: '', // 绑定状态
                activateStatus: '', // 激活状态

            },
            tableData: [],
            loading: true, // 表格加载
            total: 0, // 总数
            pageSize: 10, // 条数
            pagelndex: 1, // 页数
        }
    },
    methods: {
        /*打开详情*/
        goDetail(row) {
            let self = this;
            let params = row.id;
            self.$router.push({
                path: '/merchant/manage/detail',
                query: {
                    id: params
                }
            });
        },
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pageSize = val;
            this.manageListFunc();
        },
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.pageIndex = val;
            this.manageListFunc();
        },
        // 渲染列表
        manageListFunc() {
            // console.log(this.pageSize)
            const params = {
                activateStatus: this.form.activateStatus,
                nameOrPhoneNo: this.form.nameOrPhoneNo,
                merchantNameOrMerchantId: this.form.merchantNameOrMerchantId,
                bindStatus: this.form.bindStatus,
                snCode: this.form.snCode,
                productCode: this.form.productCode,
                pageSize: this.pageSize,
                pageIndex: this.pageIndex,
            }
            // console.log(params.pageIndex)
            // console.log({ ...params })
            // console.log('查询', merchantNameOrMerchantId);
            merchantApi.getManage({ ...params }).then(res => {
                // console.log(res)
                this.tableData = res.data.records;
                this.total = res.data.total
                // console.log(res);
                this.loading = false;
            }).catch(err => {
                // console.log(err);
            })
        },

        // 查询按钮
        queryFunc() {
            // console.log('输入框：', this.form.name)
            this.manageListFunc();
        },
        // 重置
        clearFunc() {
            this.form.snCode = '';
            this.form.bindStatus = '';
            this.form.merchantNameOrMerchantId = '';
            this.form.nameOrPhoneNo = '';
            this.form.productCode = '';
            this.form.activateStatus = '';
            this.manageListFunc();
        },

        onExport: function() {
          let self = this;
          const Params = {
            activateStatus: self.form.activateStatus,
            nameOrPhoneNo: self.form.nameOrPhoneNo,
            merchantNameOrMerchantId: self.form.merchantNameOrMerchantId,
            bindStatus: self.form.bindStatus,
            snCode: self.form.snCode,
            productCode: self.form.productCode,
          }
          Params.token = getCookie('token');
          let baseUrl = window.location.protocol + '//' + window.location.host;
          window.location.href = baseUrl + '/api/shop/merchant/merchant/export?' + qs.stringify(Params);
        },
    },
    mounted() {
        this.manageListFunc();
    }
}
</script>

<style scoped>
.marginTop {
    margin-top: 20px;
}

.query {
    margin: 20px 0 0 30px;
}

.tab {
    padding: 20px
}
</style>



// WEBPACK FOOTER //
// src/views/merchant/manage/index.vue